/* global $ */
import './styles.scss';

export default function initCarousels() {
  $('.js-carousel-slides, .js-carousel-thumbs').each((i, el) => {
    const carousel = $(el);
    const countSlides = carousel.children().length;
    if (countSlides > 1) {
      const thumbLimit = 5;
      const syncedCarousel = `#${el.getAttribute('aria-controls')}`;
      const options = {
        asNavFor: syncedCarousel,
        draggable: false,
      };

      if (el.classList.contains('js-carousel-slides')) {
        options.adaptiveHeight = true;
        options.arrows = false;
        options.fade = true;
      } else {
        options.arrows = true;
        options.dots = countSlides > thumbLimit;
        options.focusOnSelect = true;
        options.slidesToShow = thumbLimit;
        options.slidesToScroll = 1;
      }

      carousel.slick(options);
    }
  });
}
